import { Button } from '@Components/Control/Button';
import Modal from '@Components/Feedback/Modal';
import { Container } from '@Components/Layout/Container';
import { Flex } from '@Components/Layout/Flex';
import { useAppContext } from '@Containers/AppContainer';
import Sidebar from '@Containers/Layout/Sidebar';
import { cn } from '@Core/Helpers';
import React, { lazy, ReactNode } from 'react';
import { useMatches } from 'react-router';

export default function LayoutContainer({ children }: { children: ReactNode }) {
    const matches = useMatches();
    const currentHandle = matches[matches.length - 1]?.handle as {
        layout: 'full' | undefined
    } | undefined;
    const layout = currentHandle?.layout === 'full' ? 'full' : 'default';
    const { version } = useAppContext();

    return (
        <div className="bg-gray-50 h-full lg:flex">
            <Sidebar />

            {/*Content*/}
            <Container className={cn(
                layout === 'default'
                    ? 'max-w-5xl lg:max-w-7xl lg:w-3/4'
                    : '',
                '-mt-23 pt-32 mx-auto h-full flex flex-col',
                'md:px-8',
                'lg:ml-60 lg:mt-0 lg:pt-16',
                "xl:px-16 xl:ml-[20%]",
                '2xl:ml-[25%]',
            )} fullContainer={layout === 'full'}>
                {children}

                <footer className="mt-auto">
                    <Flex
                        className="mt-8 lg:my-8 py-8 border-t border-gray-400 px-8 md:px-0 flex-col md:flex-row md:justify-between"
                    >
                        <p>&copy; Jurjen</p>

                        <Modal
                            modalContent={lazy(() => import('@Modules/Version/VersionModal'))}
                            size="lg"
                        >
                            <Button variant="link" className="text-gray-900">
                                {version}
                            </Button>
                        </Modal>
                    </Flex>
                </footer>
            </Container>
        </div>
    );
}
